import { shadeColor } from 'utils';
import { BASE_COLORS } from '../constants';
import { ITheme } from '../types';

export const lightColorsTheme: ITheme = {
  semantic: {
    brandPrimary: '#7A69F6',
    brandPrimaryHover: '#5544C1',
    brandAccent: '#45E16A',
    navigationSurface: '#252461',
    navigationText: '#FFFFFF',
    surfacePage: '#FFFFFF',
    surfaceContainer: '#FFFFFF',
    surfaceElevated: '#FFFFFF',
    surfaceMuted: '#F2F7FF',
    surfaceHover: '#F7F8FF',
    surfaceSelected: '#DDE8FD',
    surfaceDisabled: '#EDF0F7',
    textPrimary: '#252461',
    textSecondary: '#535866',
    textMuted: '#a3b7da',
    textDisabled: '#8A8F9B',
    textOnBrand: '#FFFFFF',
    textOnLight: '#252461',
    borderSubtle: '#C6D9ED',
    borderStrong: '#AEB6C7',
    focusRing: '#6756D6',
    overlayScrim: 'rgba(20, 22, 43, 0.42)',
    shadowElevated: '0 4px 16px rgba(20, 22, 43, 0.14)',
    shadowOverlay: '0 12px 36px rgba(20, 22, 43, 0.2)',
    statusSuccessText: '#52C41A',
    statusSuccessSurface: '#EAF8EE',
    statusSuccessBorder: '#65AA78',
    statusWarningText: '#FAAD14',
    statusWarningSurface: '#FFFBE6',
    statusWarningBorder: '#FFE58F',
    statusErrorText: '#FF4D4F',
    statusErrorSurface: '#FFF0F2',
    statusErrorBorder: '#DB6D78',
    statusInfoText: '#255D8F',
    statusInfoSurface: '#EAF4FF',
    statusInfoBorder: '#7CA8CF',
    highlightSurface: '#FFE8A3',
    highlightText: '#3A2A00',
    authPanelBackground: 'rgba(37, 36, 97, 0.86)',
    scheduleTagBackground: '#E3F2FD',
    exportAction: '#237A3B',
  },
  primary: '#01509A',
  primary1: '#f5f5f5',
  primaryGradient: 'linear-gradient(211.49deg, #006CCF 15.89%, #00509A 48.97%)',
  light: '#C5D3E0',
  secondary: '#0085FF',
  error: '#FF5252',
  mediumErrorColor: '#FFE0DF',
  darkError: '#f44942',
  warning: '#FFB155',
  success: '#30AF5B',
  background: BASE_COLORS.white,
  secondaryBackground: '#F8FBFF',
  secondaryBackgroundSelected: shadeColor('#F8FBFF', -5),
  additionalBackground: '#ffffff',
  collapseBackground: 'pink',
  timelineBackground: '#F8FBFF',
  siderBackground: '#ffffff',
  spinnerBase: '#f42f25',
  scroll: '#c5d3e0',
  border: '#cce1f4',
  borderNft: '#79819A',
  textMain: '#404040',
  textLight: '#6D7280',
  textSuperLight: '#BEC0C6',
  textSecondary: BASE_COLORS.white,
  textDark: '#404040',
  textNftLight: '#79819A',
  textSiderPrimary: '#FFB765',
  textSiderSecondary: '#ffffff',
  subText: '#5F6472',
  shadow: 'rgba(0, 0, 0, 0.07)',
  boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.07)',
  boxShadowHover: '0 4px 16px 0 rgba(0, 0, 0, 0.2)',
  boxShadowNft:
    '0px 16px 24px rgba(0, 0, 0, 0.06), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  boxShadowNftSecondary:
    '0px 10px 20px rgba(0, 0, 0, 0.04), 0px 2px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
  dashboardMapBackground: '#EAF5FF',
  dashboardMapCircleColor: '#9BC2E7',
  dashboardMapControlDisabledBackground: '#c5d3e0',
  notificationSuccess: '#EFFFF4',
  notificationPrimary: '#D7EBFF',
  notificationWarning: '#FFF4E7',
  notificationError: '#FFE2E2',
  heading: '#13264d',
  borderBase: '#AEB6C7',
  disable: 'rgba(0, 0, 0, 0.25)',
  disabledBg: '#c5d3e0',
  layoutBodyBg: '#f8fbff',
  layoutHeaderBg: 'transparent',
  layoutSiderBg: 'linear-gradient(261.31deg, #006ccf -29.57%, #00509a 121.11%)',
  inputPlaceholder: '#686D77',
  itemHoverBg: '#f5f5f5',
  backgroundColorBase: '#F5F5F5',
  avatarBg: '#ccc',
  alertTextColor: BASE_COLORS.white,
  breadcrumb: 'rgba(0, 0, 0, 0.45)',
  icon: '#a9a9a9',
  iconHover: 'rgba(0, 0, 0, 0.75)',
};
